import { styled } from 'styled-components';

import { colors } from 'src/css/theme';
import { useInventoryLedger } from 'src/queries/v2/delivery/inventory-ledger';
import { useAppSelector } from 'src/utils';

export const InventoryLedger = () => {
  const selectedRoute = useAppSelector((state) => state.user.selectedRouteId);
  const { data: ledger } = useInventoryLedger({ routeId: selectedRoute || 0, enabled: !!selectedRoute });

  if (!ledger) {
    return null;
  }

  return (
    <>
      {ledger.CarInventory?.length > 0 && (
        <>
          <h3>Car Inventory</h3>
          <HeaderRow>
            <NameCol>Product</NameCol>
            <Col>Quantity</Col>
          </HeaderRow>
          {ledger.CarInventory?.map((item) => (
            <Row key={item.id}>
              <NameCol>
                <div>{item.ProductName}</div>
                <div>{item.SerialNumber}</div>
              </NameCol>
              <Col>
                {item.Quantity}
                {' ' + item.Unit}
              </Col>
            </Row>
          ))}
        </>
      )}
      {ledger.SoldInventory?.length > 0 && (
        <>
          <h3>Sold Inventory</h3>
          <HeaderRow>
            <NameCol>Product</NameCol>
            <Col>Quantity</Col>
          </HeaderRow>
          {ledger.SoldInventory?.map((item) => (
            <Row key={item.id}>
              <NameCol>
                <div>{item.ProductName}</div>
                <div>{item.SerialNumber}</div>
              </NameCol>
              <Col>
                {item.Quantity}
                {' ' + item.Unit}
              </Col>
            </Row>
          ))}
        </>
      )}
    </>
  );
};

const NameCol = styled.div`
  margin: 0.25rem;
  width: 75%;
`;

const Col = styled.div`
  margin: 0.5rem;
  width: 25%;
`;

const HeaderRow = styled.div`
  border-bottom: 1px var(--color-gray-60) solid;
  display: flex;
  justify-content: space-between;
  color: ${colors.dutchie.almostBlack};
  font-size: 1rem;
  line-height: 2rem;
  font-weight: 600;
`;

const Row = styled.div`
  &:nth-child(odd) {
    background: var(--color-gray-10);

  }
  background: 
  font-size: 1rem;
  line-height: 162%;
  display: flex;
  justify-content: space-between;
`;
